import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ImportUserService {

constructor(private ws: PostmethodService) { }

   bulkUpload(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.loginUrl + "/reports/bulkImportUser");
  }

  bulkUploadDSE(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.loginUrl + "/reports/bulkImportDSEUser");
  }
  
  bulkUploadDD(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.loginUrl + "/reports/bulkImportDDUser");
  }

  uploadBucket(request: any) {
    return this.ws.wsPostFile(request, environment.loginUrl + "/reports/presigned-url");
  }

  uploadFileByUrl(requestUrl: any, file:File) {
    return this.ws.wsPutByUrl(requestUrl,file);
  }
}
